import { UserProfile } from "@/app/@types";
import { supabase } from "../supabase-client";

export const updateUserProfile = async (
  userId: string,
  updates: Partial<UserProfile>
): Promise<UserProfile | null> => {
  try {
    if (!userId) {
      console.error("User ID is required");
      return null;
    }

    if (!updates || Object.keys(updates).length === 0) {
      console.error("Updates are required");
      return null;
    }

    const { data: existingUser, error: fetchError } = await supabase
      .from("user_profiles")
      .select("*")
      .eq("id", userId)
      .single();

    if (fetchError) {
      console.error("Error checking existing user:", fetchError);
      return null;
    }

    if (!existingUser) {
      console.error("User profile not found");
      return null;
    }

    const { data, error } = await supabase
      .from("user_profiles")
      .update({ 
        ...updates, 
        updated_at: new Date().toISOString() 
      })
      .eq("id", userId)
      .select()
      .single();
      
    if (error) {
      console.error("Error updating user profile:", error);
      return null;
    }

    if (!data) {
      console.error("No data returned after updating profile");
      return null;
    }

    return data;

  } catch (error) {
    console.error("Unexpected error updating user profile:", error);
    return null;
  }
};